module.exports = __webpack_public_path__ + "img/edit-image-icon.870dd496.png";